import React from 'react'
import { getPartnersData } from '../createPages/partners/createPartnerPages.utils'
import { Logout } from '../styles/preview'

//* utils
import MODULE_MAPPING from '../../preview/constants/contentIDs'
import { pageTemplate } from '../../preview/layout/layout'
import { getContentfulData } from '../../preview/preview.utils'
import cache from '../../preview/utils/cache/cache'
import { getPageType } from '../../preview/utils/get/paths'
import { verifyLoginToken } from '../../preview/utils/verifyLoginToken'

const SSRPage = (props: any) => {
  console.log('SERVER DATA:', props)
  console.log('IS_SSR', process.env.IS_SSR)

  const handleClick = (e: any) => {
    e.preventDefault()
    document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
    window.location.href = `${window.location.origin}/login`
    return false
  }

  if (!props.serverData) return ''
  else if (props?.serverData?.message) return props.serverData.message
  else
    return (
      <>
        <Logout onClick={handleClick}>Log out</Logout>
        {pageTemplate(props?.serverData)}
      </>
    )
}

export default SSRPage

export async function getServerData(context: any) {
  const slug = context?.params?.['*']
  let queryPath = slug ? `?path=${slug}` : ''

  //* Exclude authentication process for local development
  //* NOTE: If you want to test, redirects only work if you run a gatsby build and gatsby serve
  if (!process.env.DISABLE_PREVIEW_AUTHENTICATION) {
    const isValid = await verifyLoginToken(context?.headers?.get('cookie') || '')
    if (!isValid) {
      return {
        status: 302,
        headers: {
          location: `/login${queryPath}`,
          'Set-Cookie': `token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`,
        },
      }
    }
  }

  //* use query for no cache
  if (context?.query?.['no-cache'] === 'true') {
    cache.reset()
  }

  const pageType = getPageType(slug)

  if (
    pageType === MODULE_MAPPING.PAGE_BUSINESS_PARTNERS ||
    pageType === MODULE_MAPPING.PAGE_SERVICE_PARTNERS ||
    pageType === MODULE_MAPPING.PAGE_TECHNOLOGY_ALLIANCES ||
    pageType === MODULE_MAPPING.PAGE_PUBLIC_SECTOR_PARTNERS ||
    Object.keys(cache.get('partners')).length === 0
  ) {
    try {
      //* this doesnt work in data/partner, gatsby perceives it as client side code and mongo doesn't work client side
      const partnerData = await getPartnersData()
      cache.set('partners', partnerData)
    } catch (err) {
      console.info('Error getting partners data:', err)
    }
  }

  if (!process.env.IS_PREVIEW) {
    return {
      status: 404,
      headers: {},
      props: { data: 'preview is not enabled' },
    }
  }

  try {
    const data: any = await getContentfulData(slug)

    if (Object.keys(data.pageData).length === 0) {
      return {
        status: 404,
        headers: {},
        props: {
          ...data,
        },
      }
    } else {
      return {
        status: 200,
        props: {
          ...data,
        },
      }
    }
  } catch (err) {
    return {
      status: 500,
      headers: {},
      props: { error: `Cannot load page: ${err}` },
    }
  }
}
